import {
	lazy,
} from 'react'

export const ClubsCreatePageAsync = lazy(async() => {
	return import('./clubs-create.page')
})
